import { Link } from "react-router-dom";
import styled from "styled-components";

export const AuthTitle = styled.h1`
  margin: 0 0 0.35rem;
  font-size: clamp(1.375rem, 1.1rem + 1vw, 1.75rem);
  font-weight: 800;
  letter-spacing: -0.02em;
  color: hsl(${({ theme }) => theme.colors.foreground});
  text-align: center;
`;

export const AuthSub = styled.p`
  margin: 0 0 1.75rem;
  font-size: clamp(0.875rem, 0.82rem + 0.2vw, 0.9375rem);
  line-height: 1.5;
  color: hsl(${({ theme }) => theme.colors.mutedForeground});
  text-align: center;
  max-width: 22rem;
  margin-left: auto;
  margin-right: auto;
`;

export const Divider = styled.div`
  height: 3px;
  width: 2.5rem;
  border-radius: ${({ theme }) => theme.radius.full};
  margin: 0 auto 1.25rem;
  background: linear-gradient(
    90deg,
    hsl(${({ theme }) => theme.colors.primary}),
    hsl(${({ theme }) => theme.colors.accent})
  );
`;

export const Label = styled.label`
  display: block;
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: hsl(${({ theme }) => theme.colors.mutedForeground});
  margin-bottom: 0.35rem;
`;

export const LabelRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 0.5rem;
  margin-bottom: 0.35rem;
`;

export const Input = styled.input`
  width: 100%;
  box-sizing: border-box;
  border: 1px solid hsl(${({ theme }) => theme.colors.border});
  border-radius: ${({ theme }) => theme.radius.lg};
  padding: 0.65rem 0.85rem;
  font-size: clamp(0.9375rem, 0.88rem + 0.2vw, 1rem);
  background: hsl(${({ theme }) => theme.colors.card});
  color: hsl(${({ theme }) => theme.colors.foreground});
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
  &::placeholder {
    color: hsl(${({ theme }) => theme.colors.mutedForeground});
    opacity: 0.85;
  }
  &:hover {
    border-color: hsl(${({ theme }) => theme.colors.primary} / 0.35);
  }
  &:focus {
    border-color: hsl(${({ theme }) => theme.colors.primary});
    box-shadow: 0 0 0 3px hsl(${({ theme }) => theme.colors.primary} / 0.18);
  }
`;

export const PassWrap = styled.div`
  position: relative;
`;

export const TogglePass = styled.button`
  position: absolute;
  right: 0.65rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border: none;
  border-radius: ${({ theme }) => theme.radius.md};
  background: transparent;
  color: hsl(${({ theme }) => theme.colors.mutedForeground});
  cursor: pointer;
  &:hover {
    color: hsl(${({ theme }) => theme.colors.primary});
    background: hsl(${({ theme }) => theme.colors.primary} / 0.08);
  }
`;

export const Field = styled.div`
  margin-bottom: 1.125rem;
`;

export const ForgotLink = styled(Link)`
  font-size: 0.8125rem;
  font-weight: 500;
  color: hsl(${({ theme }) => theme.colors.primary});
  &:hover {
    text-decoration: underline;
    color: hsl(${({ theme }) => theme.colors.primary} / 0.85);
  }
`;

export const Submit = styled.button`
  width: 100%;
  margin-top: 0.25rem;
  padding: 0.7rem 1rem;
  border: none;
  border-radius: ${({ theme }) => theme.radius.lg};
  font-size: clamp(0.9375rem, 0.88rem + 0.2vw, 1rem);
  font-weight: 700;
  cursor: pointer;
  background: hsl(${({ theme }) => theme.colors.primary});
  color: hsl(${({ theme }) => theme.colors.primaryForeground});
  box-shadow: 0 2px 0 hsl(${({ theme }) => theme.colors.navDark} / 0.12);
  transition: opacity 0.15s, transform 0.1s;
  &:hover:not(:disabled) {
    opacity: 0.94;
  }
  &:active:not(:disabled) {
    transform: translateY(1px);
  }
  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

export const Footer = styled.p`
  text-align: center;
  font-size: 0.875rem;
  color: hsl(${({ theme }) => theme.colors.mutedForeground});
  margin: 1.5rem 0 0;
  padding-top: 1.25rem;
  border-top: 1px solid hsl(${({ theme }) => theme.colors.border});
`;

export const FooterLink = styled(Link)`
  font-weight: 600;
  color: hsl(${({ theme }) => theme.colors.primary});
  &:hover {
    text-decoration: underline;
  }
`;

export const Err = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  margin: 0 0 1.25rem;
  border-radius: ${({ theme }) => theme.radius.lg};
  font-size: 0.875rem;
  line-height: 1.45;
  color: hsl(${({ theme }) => theme.colors.couponMaroon});
  background: hsl(${({ theme }) => theme.colors.couponMaroon} / 0.08);
  border: 1px solid hsl(${({ theme }) => theme.colors.couponMaroon} / 0.2);
`;

export const Ok = styled.div`
  padding: 0.85rem 1rem;
  margin: 0 0 1.25rem;
  border-radius: ${({ theme }) => theme.radius.lg};
  font-size: 0.875rem;
  line-height: 1.5;
  text-align: center;
  color: hsl(${({ theme }) => theme.colors.foreground});
  background: hsl(${({ theme }) => theme.colors.accent} / 0.12);
  border: 1px solid hsl(${({ theme }) => theme.colors.accent} / 0.28);
`;
